module.exports = __webpack_public_path__ + "static/img/banner3.9045ac2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner3.jpg
// module id = Irxm
// module chunks = 9